import { useEffect, useState } from "react";
import {
  IDeltaHedgeExeDetailedStateTableReport,
  IDeltaHedgeExeDetailedStateTableSearchParam,
} from "../../../Interfaces/deltaHedgeExe";
import UsersDropdown from "../../../Components/Dropdown/Users/UsersDropdown";
import DetailedStateTable from "../../../Tables/DeltaHedgeExePhase3/DetailedState/DetailedStateTable";
import SelectableButtons from "../../../Components/Dropdown/SelectableButtons";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import { getGroups } from "../../../Requests/optionDomain";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import Charts from "./Charts";
import TablesWrapper from "./TablesWrapper";
import ExeStatus from "../../../Tables/DeltaHedgeExePhase3/DetailedState/ExeStatus/ExeStatus";
import ReferenceTable from "../../../Tables/OptionDomain/Adjustment2/ReferenceTable";
// Common Components
import { DynamicDropdown } from "src/Components";
// Requests
import { getDeltaHedgeAccountsForPortfoDropdown } from "src/Requests/deltaHedgeAccounts";
// Reducers
import { setSearchParam } from "src/Features/DeltaHedgeExePhase3/deltaHedgeExePhase3Slice";
// Hooks
import { useAppDispatch, useAppSelector } from "../../../App/hooks";

interface ISelectedRowInfo {
  id: number;
  delta: number; // DeltaPercent
  gamma: number; //GammaPercent
  deltahedgeAccountId: number;
  accountId: number;
}

const DetailedState = () => {
  // hooks
  const dispatch = useAppDispatch();
  // local store
  const [groups, setGroups] = useState([] as DropdownItem[]);
  const [selectedRowInfo, setSelectedRowInfo] =
    useState<ISelectedRowInfo | null>(null);
  // store
  const searchParam = useAppSelector(
    (store) => store.deltaHedgeExePhase3Slice.searchParam,
  );

  useEffect(() => {
    getGroups()
      .then((resp) => {
        setGroups(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    dispatch(setSearchParam({ ...searchParam, [name]: value }));
  };

  const tableRowClickHandler = (
    row: IDeltaHedgeExeDetailedStateTableReport,
  ) => {
    setSelectedRowInfo({
      id: row.id,
      delta: row.targetDelta,
      gamma: row.targetGamma,
      accountId: row.accountId,
      deltahedgeAccountId: row.deltahedgeAccountId,
    });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <div className="flex flex-row justify-start items-start gap-5">
        <div className="w-[200px]">
          {/* <UsersDropdown
            name="accountId"
            label="نام اکانت"
            onChange={changeHandler}
            extraLabel
            value={searchParam.accountId}
          /> */}
          <DynamicDropdown
            dropdown={{
              name: "accountId",
              placeholder: "نام اکانت",
              extraLabel: true,
            }}
            getData={getDeltaHedgeAccountsForPortfoDropdown}
            value={searchParam.accountId}
            onChange={changeHandler}
          />
        </div>
        <SelectableButtons
          label="*گروه"
          name="groupId"
          options={groups}
          onChange={changeHandler}
          value={searchParam.groupId?.toString() || 5}
        />
      </div>
      {searchParam.groupId || searchParam.groupId === null ? (
        <div className="flex flex-row justify-start items-start gap-3 w-full">
          <DetailedStateTable
            searchParams={searchParam}
            onTableRowClick={tableRowClickHandler}
            activeRowId={selectedRowInfo?.id}
          />
          <div className="flex flex-col justify-start items-start">
            {searchParam.groupId ? (
              <ReferenceTable
                searchParams={{ groupId: searchParam.groupId } as any}
              />
            ) : (
              <></>
            )}
            {selectedRowInfo && searchParam.groupId ? (
              <ExeStatus
                searchParams={{
                  taskId: selectedRowInfo.id,
                  id: selectedRowInfo.id,
                }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
      {selectedRowInfo && searchParam.groupId ? (
        <div className="flex flex-col justify-start items-start gap-5 w-full">
          <Charts activeRowId={selectedRowInfo.id} />
          <TablesWrapper
            searchParams={{
              accountId: selectedRowInfo.accountId,
              id: selectedRowInfo.id,
              groupId: searchParam.groupId,
              userPoint: {
                delta: selectedRowInfo.delta,
                gamma: selectedRowInfo.gamma,
              },
              incDelta: false,
              incGamma: false,
              deltahedgeAccountId: selectedRowInfo.deltahedgeAccountId,
            }}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DetailedState;
